import React, { useState } from 'react';
import AllStatesSearchFields from './AllStatesSearchViewComponents/AllStatesSearchFields';
import AllStatesCurrentSearch from './AllStatesSearchViewComponents/AllStatesCurrentSearch';
import AllStatesPreviousSearches from './AllStatesSearchViewComponents/AllStatesPreviousSearches';
import { Toast } from 'components/shared/Toaster'
import { requestAllStatesSearch, requestSosSearch } from 'actions/applicants'
import AllStatesSavedRecords from './AllStatesSearchViewComponents/AllStatesSavedRecords';

const AllStatesSearchView = (props) => {

    const { viewResult, applicantId, creditCosts } = props

    // data
    const [currentSearch, setCurrentSearch] = useState(false)
    const [searchLoading, setSearchLoading] = useState(false)

    // control variables
    const [update, setUpdate] = useState(false) // update previous searches

    //functions 
    const handleAllStatesSearch = (payload) => {
        setSearchLoading(true)
        setCurrentSearch(false)
        let info = { payload, applicationId: applicantId }
        requestAllStatesSearch(info)()
            .then(res => {
                setCurrentSearch(res)
                setUpdate(prev => !prev)
            })
            .catch(err => Toast({ type: 'error', message: 'Search failed. Please try again.' }))
            .finally(() => setSearchLoading(false))
    }

    const handleSosSearch = (sosId, businessName) => {
        const payload = {
            sosId,
            businessName
        }
        let info = { payload, applicationId: applicantId }
        return requestSosSearch(info)()
            .then(res => {
                Toast({ type: 'success', message: 'Search completed successfully!' })
                return res
            })
            .catch(err => {
                Toast({ type: 'error', message: 'Search failed. Please try again.' })
                throw err
            })
    }

    return (
        <>
            <div className='cardStyle mb-3'>
                <h5 className='mb-0'>All States Search</h5>
                <AllStatesSearchFields
                    loading={searchLoading}
                    handleAllStatesSearch={handleAllStatesSearch}
                    creditCosts={creditCosts}
                />
                {
                    currentSearch &&
                    <AllStatesCurrentSearch
                        currentSearch={currentSearch}
                        viewResult={viewResult}
                        search={handleAllStatesSearch}
                        applicantId={applicantId}
                    />
                }
            </div>
            <AllStatesPreviousSearches
                update={update}
                viewResult={viewResult}
                search={handleAllStatesSearch}
                searchAlternative={handleSosSearch}
                searchLoading={searchLoading}
                applicantId={applicantId}
                creditCosts={creditCosts}
            />
            {applicantId && <AllStatesSavedRecords applicantId={applicantId} viewResult={viewResult} />}
        </>
    )
}

export default AllStatesSearchView